import React, { ReactNode, forwardRef } from "react"

import { NavLink } from "react-router-dom"

import { Color, Size } from "~tailwindui/types/enums"

import { buttonClassNames } from "~tailwindui/helpers/classNameHelpers"

import classNames from "src/classNames"

export type StyledLinkProps = {
  to: string
  children: ReactNode
  button?: boolean
  size?: Size
  color?: Color
  outline?: boolean
  soft?: boolean
  className?: string
  target?: string
  rel?: string
}

const StyledLink: React.FC<
  StyledLinkProps & Omit<React.HTMLProps<HTMLAnchorElement>, "size">
> = forwardRef<HTMLAnchorElement, StyledLinkProps>(
  (
    {
      to,
      children,
      button = false,
      size = Size.Medium,
      color = Color.Blue,
      outline = false,
      soft = false,
      className = "",
      ...rest
    },
    ref
  ) => {
    return (
      <NavLink
        ref={ref}
        to={to}
        onClick={e => e.stopPropagation()}
        className={classNames(
          "inline-block",
          button
            ? buttonClassNames({ size, color, outline, soft })
            : "text-sky-600 hover:underline",
          className
        )}
        {...rest}
      >
        {children}
      </NavLink>
    )
  }
)

export default StyledLink
